import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import { AuditOutlined, CalendarOutlined } from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import POOverviewDetails from "./POOverviewDetails";

const MerchantPOOverview = () => {
  const [merchantsPOList, setMerchantsPOList] = useState({
    data: [],
    ready: false,
  });
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedData, setSelectedData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedPOStatus, setSelectedPOStatus] = useState("all");
  const [selectedMerchant, setSelectedMerchant] = useState("all");
  const [selectedEmployee, setSelectedEmployee] = useState("all");

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Merchant PO Number",
      dataIndex: "po_number",
      render: (text, record) => (
        <p
          style={{
            color: "blue",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Merchant",
      render: (text, record) => <p>{text.posavemerchantinfo.business_name}</p>,
    },

    {
      title: "Acknowledge By",
      render: (text, record) => (
        <p>
          {text.rawprodpocomemployee !== null
            ? `${text.rawprodpocomemployee.firstname} ${text.rawprodpocomemployee.lastname}`
            : ""}{" "}
        </p>
      ),
    },
    {
      title: "Delivery Status",
      align: "center",
      render: (text, record) => (
        <p>
          {text.po_status === "new"
            ? "P.O Placed"
            : text.po_status === "acknowledge"
            ? "Acknowledged"
            : text.po_status === "preparing"
            ? "Preparing"
            : text.po_status === "ready"
            ? "Ready To Deliver"
            : text.po_status === "in-transit"
            ? "In Transit"
            : text.po_status === "arrived"
            ? "Arrived"
            : "Completed"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantPOList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/po-list/by-employee-id", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantsPOList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getMerchantList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/merchant-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getEmployeeList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantPOList();
    getMerchantList();
    getEmployeeList();
  }, [getMerchantPOList, getMerchantList, getEmployeeList]);

  const searchable = merchantsPOList.data.filter((data) => {
    return (
      data.po_number.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.posavemerchantinfo.business_name
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      date_to: moment(new Date(values.date_to), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      user_id: userData.data.id,

      acknowledge_by: selectedEmployee,
      merchant_id: selectedMerchant,
      po_status: selectedPOStatus,
    };
    setLoading(true);
    axios
      .get("user/commissary/filter/po-list/by-employee-id", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setMerchantsPOList({ data, ready: true });
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            placeholder="Search P.O # or merchant"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Tooltip title="Filter by date">
          <Button
            icon={<CalendarOutlined />}
            style={{ marginLeft: 5 }}
            onClick={() => setOpenFilterByDate(true)}
          >
            Filter
          </Button>
        </Tooltip>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.po_number_id}
        />
      </div>

      {openDrawer && (
        <POOverviewDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{
            po_status: selectedPOStatus,
            acknowledge_by: selectedEmployee,
            user_id: selectedMerchant,
          }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="user_id"
              label="Merchant"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="-"
                onChange={(e) => setSelectedMerchant(e)}
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"all"}>All</Select.Option>
                {merchantList.ready &&
                  merchantList.data.length > 0 &&
                  merchantList.data.map((data, index) => (
                    <Select.Option value={data.user_id} key={index}>
                      {data.business_name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="acknowledge_by"
              label="Acknowledge By"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="-"
                onChange={(e) => setSelectedEmployee(e)}
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"all"}>All</Select.Option>
                {employeeList.ready &&
                  employeeList.data.length > 0 &&
                  employeeList.data.map((data, index) => (
                    <Select.Option
                      value={data.employee_user_id}
                      key={index}
                    >{`${data.firstname} ${data.lastname}`}</Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="po_status"
              label="Delivery Status"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="-"
                onChange={(e) => setSelectedPOStatus(e)}
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"all"}>All</Select.Option>
                <Select.Option value={"new"}>P.O Placed</Select.Option>
                <Select.Option value={"acknowledge"}>
                  Acknowledged
                </Select.Option>
                <Select.Option value={"preparing"}>Preparing</Select.Option>
                <Select.Option value={"ready"}>Ready to Deliver</Select.Option>
                <Select.Option value={"in-transit"}>In Transit</Select.Option>
                <Select.Option value={"arrived"}>Arrived</Select.Option>
                <Select.Option value={"completed"}>Completed</Select.Option>
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MerchantPOOverview;
